import { basicPath } from '../basicPath';

export const fetchStampParams = (params) => async (dispatch) => {
    const path = '/mp/stamp-params/all';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}